import { render, staticRenderFns } from "./createclearinghousefile.vue?vue&type=template&id=5c53bdae&"
import script from "./createclearinghousefile.vue?vue&type=script&lang=js&"
export * from "./createclearinghousefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports